// extracted by mini-css-extract-plugin
export default {"highlightText":"bwT4vRbsZjttz2FRlBmQ","rowStyle":"mokHv0sLB9oInPWQNrPA","bcrsTag":"kHSlcVJ6wkWqc6q50IKw"};